import React from 'react';

const policySections = [
    `This page tells you the terms of use on which you may make use of our
    website, whether as a guest or a registered user. Please read these terms
    of use carefully before you start to use the site. By using our site, you
    indicate that you accept these terms of use and that you agree to abide by
    them. The NEINS will not be responsible for any damage suffered by you from
    use of the online services on this site.`,
    `Use of any information at the website(s) is at one's own risk. While every
    effort is made to secure our network communication, however, NEINS may not
    always be able to ensure the privacy of online communication and other
    information of the visitors, unless otherwise specifically provided for. No
    data transmission over the Internet can be guaranteed as totally secure. As
    a result, while we strive to protect user's personal information, NEINS
    cannot ensure or warrant the security of any information transmitted to us,
    and users do so at their own risk. It makes every effort to ensure its
    security on its systems. Ultimately, you are solely responsible for keeping
    your passwords and/or account information secret. You should be careful and
    responsible whenever you are online. Moreover, any information that one
    provides using this website(s) may become part of a public record subject
    to disclosure under the relevant regulations from time to time.`,
    `We will never share, sell, or rent individual personal information with
    anyone for their promotional use. Information submitted to us is only
    available to employees managing this information for purposes of contacting
    you or sending you emails and SMS based on your request for information,
    and to contracted service providers for purposes of providing services
    relating to our communications with you.`,
    `Our web site may contain links to other web sites and those third party
    web sites may collect personal information about you. We are not
    responsible for the privacy practices of other businesses or the content of
    web sites that are linked to our web site.`,
    `You must not misuse our site by knowingly introducing viruses, Trojans,
    worms, logic bombs or other material which is malicious or technologically
    harmful. You must not attempt to gain unauthorised access to our site, the
    server on which our site is stored or any server, computer or database
    connected to our site. You must not attack our site via a denial-of-service
    attack or a distributed denial-of service attack. By breaching this
    provision, you would commit a offence. We will report any such breach to
    the relevant law enforcement authorities and we will co-operate with those
    authorities by disclosing your identity to them. In the event of such a
    breach, your right to use our site will cease immediately. We will not be
    liable for any loss or damage caused by a distributed denial-of-service
    attack, viruses or other technologically harmful material that may infect
    your computer equipment, computer programs, data or other proprietary
    material due to your use of our site or to your downloading of any material
    posted on it, or on any website linked to it.`,
    `Online fee payments made through this application are processed via the
    applicable or respective payment gateway integrated. NEINS does not store
    or have access to your card details, UPI PIN, CVV, net banking password,
    or any other sensitive payment information.`,
    `Transaction fees charged would not be refunded by any means for any refund,
    reversal or chargeback of any payment. Transaction charges would be borne
    by the Cardholder for any payment of fees. If Transaction charges are borne
    by NEINS in special cases or in privileges, then in case of any refund,
    reversal or chargeback of that payment received will be subject to
    deduction of Transaction charges paid for that particular transaction.
    Transaction Fees once paid are not refundable. You will have to contact
    NEINS authority for any cancellation or dispute.`,
    `In case of Transaction failure and where payment is deducted from your
    account, but not updated in your NEINS Web Panel or App then wait at least
    48 hrs. Do not initiate further payment so that there is no double payment
    for that particular installment of fees. If still not updated then contact
    with NEINS along with the copy of email Receipt or any other proof of
    transaction. You will receive the payment back to the same account or card
    from where the payment was initially made. However, it may take up to 7-10
    working days for the respective banks to process the refund and reflect in
    your credit/debit card statement or internet banking account. Please get in
    touch with your bank directly in case of any delays after the confirmation
    of refund from us.`,
    `Agartala will have exclusive jurisdiction over any claim (including
    non-contractual disputes or claims) arising from, or related to, a visit to
    our site. These terms of use and any dispute or claim arising out of or in
    connection with them or their subject matter or formation (including
    non-contractual disputes or claims) shall be governed by and construed in
    accordance with the law of state.`,
    `In case of any changes/amendments in the Privacy Policy, we will update
    the changes on this Privacy Policy page of the NEINS website. As a result,
    please remember to refer back to this Privacy Policy regularly to review
    any amendments.`
];

const formatSection = (section) => section.replace(/\s+/g, ' ').trim();

const PrivacyPolicy = () => {
    return (
        <div className="bg-white text-black py-8 min-h-screen lg:py-12">
            <div className="container mx-auto px-4 lg:px-64">
                <h1 className="text-3xl lg:text-4xl font-bold mb-2 text-center text-gray-800">
                    Privacy policy
                </h1>
                <p className="text-center text-gray-600 mb-8">
                    Privacy Policy &amp; Terms of Use
                </p>
                <div className="text-left space-y-5">
                    {policySections.map((section, index) => (
                        <div key={index} className="flex gap-3">
                            <span className="mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-primary" />
                            <p className="text-gray-800 leading-7">{formatSection(section)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
